import { Heading, Inline, Stack, Text, textColors, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { CarrierLogo } from '@eti/components';
import { useMemo } from 'react';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import { getTripSegmentsFromBounds } from '../../utils';

const carrierLogoInfoStyles = css`
  background-color: #fff;
  height: 24px;
  width: 24px;
  z-index: 1;
`;

const flexStyles = css`
  flex: 1;
`;

const hiddenCarriersStyles = css`
  background-color: #fff;
  border: solid 1px #737373;
  height: 20px;
  left: 14px;
  position: absolute;
  text-align: center;
  top: 16px;
  width: 20px;
  z-index: 1;
`;

const positionRelativeStyles = css`
  position: relative;
`;

const AirlineInfoClickableContent = () => {
  const { t } = useTranslation();
  const { bounds } = useOrderDetails();

  const carriers = useMemo(
    () =>
      Array.from(
        new Map(
          getTripSegmentsFromBounds(bounds).map((segment) => {
            const code = segment.carrierBookingNumber?.carrierCode || segment.operatingCarrier.code;
            const name = segment.carrierBookingNumber?.carrierName || segment.operatingCarrier.name;
            return [code, { code, name }];
          }),
        ).values(),
      ),
    [bounds],
  );

  return (
    <Stack align="start" className={flexStyles}>
      <Inline>
        <div className={positionRelativeStyles}>
          {carriers[0].code && carriers[0].name && (
            <CarrierLogo
              className={carrierLogoInfoStyles}
              data-testid={`airline-info-carrier-logo-${carriers[0].code}`}
              id={carriers[0].code}
              imageAlt={carriers[0].name}
            />
          )}
          {carriers.length > 1 && (
            <Inline align="center" alignY="center" className={hiddenCarriersStyles}>
              <Text
                color={textColors.LIGHTER}
                data-testid="airline-info-number-of-hidden-carriers"
                variant={textVariants._12}
              >
                +{carriers.length - 1}
              </Text>
            </Inline>
          )}
        </div>
        <Stack className={flexStyles} spacing={8}>
          <Heading as="span" level={2}>
            {t('OrderDetails.AirlineInfoClickableContent.Title')}
          </Heading>
          <Text>{t('OrderDetails.AirlineInfoClickableContent.Subtitle')}</Text>
        </Stack>
      </Inline>
    </Stack>
  );
};

export default AirlineInfoClickableContent;
